import React, { ChangeEventHandler, FocusEventHandler } from "react";

import { useFormData } from "@sp-state/useFormData";
import InputWrapper from "../InputWrapper";

import styles from "./PhoneInput.module.scss";
import Input from "../Input";
import { getPhoneValue, isValidPhone } from "./phoneHelpers";
import { formatToPhone } from "@utils/formatToPhone";

const PhoneInput = () => {
  const { phone, setError, setValue, setIsValid } = useFormData(state => state);

  const onBlur: FocusEventHandler<HTMLInputElement> = e => {
    const phoneNumber = getPhoneValue(e.target.value);

    if (!isValidPhone(phoneNumber!)) {
      setError("phone", true);
      setIsValid("phone", false);
    }
  };

  const onChange: ChangeEventHandler<HTMLInputElement> = e => {
    const { value } = e.target;

    if (phone.hasError) setError("phone", false);

    const phoneNumber = getPhoneValue(value);

    setValue("phone", phoneNumber!);
    if (isValidPhone(phoneNumber!)) {
      setIsValid("phone", true);
    }
  };

  const errorText = phone.hasError && (
    <span className={styles.error}>This field is required.</span>
  );

  return (
    <InputWrapper label="Mobile Phone">
      <Input
        hasError={phone.hasError}
        isValid={phone.isValid}
        onBlur={onBlur}
        maxLength={16}
        onChange={onChange}
        value={formatToPhone(phone.value)}
        placeholder="(___) ___-____"
        name="phone"
        autoComplete="tel-national"
      />
      <p className={styles.fieldCopy}>
        {errorText} For text verification to access your account.
      </p>
    </InputWrapper>
  );
};

export default PhoneInput;
